var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "esTwq69ekyW1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 206 210",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "019e2d4444df4533bd2b42f897e0130e",
    "export-id": "e167d6784e5648a4b4f6cff00c5dd770",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01162,27.7946C30.0184,1.00444,24.1399,5.08114,66.8068,3.247c9.7448-.41891,23.0307-2.432782,33.3922,4.11651c15.29,9.66479,39.128,62.42909,15.008,59.11129-15.5872-2.1442-30.2332-18.5517-24.7722-32.6851C99.3905,10.612,132.474,16.646,154.982,28.2391c24.78,12.7632,41.405,37.7244,41.556,63.4489.068,11.752-12.02,19.081-19.397,1.7104-15.172-35.728,28.403-18.7949,43.876-.7172c27.87,32.5608,43.151,97.7188,13.08,116.3938-9.402,5.839-11.471-.97-11.687-7.387-.22-6.512-4.601-26.534-2.057-19.855c4.447,11.676,3.018,19.751,2.547,29.842-.609,13.016,27.463,10.608,36.503,10.777c4.746.088,13.633,2.114,18.36,5.42c9.334,6.527-20.502-4.81-30.035-10.836",
    transform: "matrix(.700295 0.175291-.177075 0.707424 27.214806-6.074916)",
    fill: "none",
    stroke: "#f55",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDashoffset: 67.660667,
    strokeDasharray: 780.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeF);
export default __webpack_public_path__ + "static/media/home-f.e9d63c18a9aeb38c2f64d78087109e2a.svg";
export { ForwardRef as ReactComponent };